// extracted by mini-css-extract-plugin
export var closed = "_9y-1";
export var resizer = "_9y-0";